"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var PlayerUIVisibilityManager = /** @class */ (function (_super) {
    tslib_1.__extends(PlayerUIVisibilityManager, _super);
    function PlayerUIVisibilityManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlayerUIVisibilityManager.prototype.UNSAFE_componentWillReceiveProps = function (_a) {
        var isPlayerUIVisible = _a.isPlayerUIVisible, showPlayerUI = _a.showPlayerUI, hidePlayerUI = _a.hidePlayerUI;
        if (isPlayerUIVisible !== this.props.isPlayerUIVisible) {
            isPlayerUIVisible // eslint-disable-line no-unused-expressions
                ? showPlayerUI && showPlayerUI()
                : hidePlayerUI && hidePlayerUI();
        }
    };
    PlayerUIVisibilityManager.prototype.render = function () {
        return null;
    };
    return PlayerUIVisibilityManager;
}(react_1.default.Component));
exports.default = PlayerUIVisibilityManager;
//# sourceMappingURL=ui-visibility-manager.js.map